module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "back-link",
    attrs: {
      "to": "/configuracoes/integracoes"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('integrations.title.index')))]), (_vm.is_pipedrive) ? _c('pipedrive') : _vm._e(), (_vm.is_rd_station) ? _c('rd-station') : _vm._e(), (_vm.is_rd_station_crm) ? _c('rd-station-crm') : _vm._e(), (_vm.is_salesforce) ? _c('salesforce') : _vm._e(), (_vm.is_hubspot) ? _c('hubspot') : _vm._e(), (_vm.is_cv_crm) ? _c('cv-crm') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2905e3a7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/index.vue
// module id = 1051
// module chunks = 1